import React, { useState, useEffect } from 'react';
import firebase from '../utils/Firebase';
import { useParams } from 'react-router-dom';
import { Link } from 'react-router-dom';
import ReactGA from 'react-ga';



import TopHeader from "../components/TopHeader";
import styled from 'styled-components'
import backBtn from "../img/back_btn.svg";
import nothingFound from "../img/nothingFound.svg";
import { Spin } from 'antd';


const SinglePromoCodeContainer = styled.div`
height:100%;
box-shadow: 0px 4px 26px rgba(0, 0, 0, 0.24);
border-radius: 10px;
overflow:hidden;
padding: 25px;
border-left: 5px solid #27AE60
`
const SingleCodeTitle = styled.div`
font-family: Kanit;
font-style: normal;
font-weight: normal;
font-size: 14px;
line-height: 24px;
text-transform: uppercase;
color:#959393;
`

const SinglePromoCode = () => {
    
    
    const [items, setItems] = useState([]); //useState() hook, sets initial state to an empty array
    const [isLoading, setisLoading] = useState(true);
    
    let { vendor } = useParams();

    useEffect(() => {
        firebase
            .firestore() //access firestore
            .collection("promocodes") //access "promocodes" collection
            .where("vendor_name", "==", vendor)
            .onSnapshot(snapshot => {
                //You can "listen" to a document with the onSnapshot() method.
                const listItems = snapshot.docs.map(doc => ({
                    //map each document into snapshot
                    key: doc.id, //id and data pushed into items array
                    ...doc.data() //spread operator merges data to id.
                }));
                setItems(listItems); //items is equal to listItems
                setisLoading(false);
            });
    }, [vendor]);

    ReactGA.event({
        category: window.location.hostname,
        action: 'Visited '+vendor
      });
      

    
    // console.log(items);
    let pageTitle = `${vendor} | Promo Codes and offers`;

    const PromoList = ()=> (<> 
    {items.length
        ? items.map((item) =>

            <div className="itemMasonary my-4" key={item.key}>
                <SinglePromoCodeContainer>
                    <SingleCodeTitle>Code</SingleCodeTitle>
                    {item.code}
                    <hr />
                    <SingleCodeTitle>Applicable For</SingleCodeTitle>
                    {item.applied_for}
                    <hr />
                    <SingleCodeTitle>Description</SingleCodeTitle>
                    {item.description}

                    {item.promo_img ? <><hr /> <SingleCodeTitle>Promo Image</SingleCodeTitle>
                        <img src={item.promo_img} alt="" width="100%" /></> : null}
                    
                        {item.validTill ? 
                        <> <hr /> <SingleCodeTitle>Validity</SingleCodeTitle> {item.validTill}</> 
                    : null }
                </SinglePromoCodeContainer> 
            </div>)
        :
        <div className="container">
            <div className="row text-center">
                <div className="my-auto">    <img src={nothingFound} alt="Nothing Found" style={{ width: "250px" }} /></div>

                <h4 className="text-muted">No promos or discounts are<br /> available for {vendor} right now !</h4>
                <p>Please come back later.<br />Surely we will have something for you. </p>
            </div>
        </div>

    }</>)

    return (
        <>
            <Link to="/"><TopHeader pageTitle={pageTitle} app_logo={backBtn} /></Link>
            <div className="container mt-2">
                <div className="masonary">
                {isLoading ? <Spin style={{marginTop:"100px"}}/>:<PromoList/>}
                </div>
            </div>

        </>);
}

export default SinglePromoCode;